import React from "react";
import { useHistory } from "react-router-dom";
import ReportList from "components/Card/ReportCard";
import { AlarmClockPlus, Pickaxe, CircleCheckBig, MessageCircle } from "lucide-react";
import { Text } from "@chakra-ui/react";

const PackageReports = ({ reports, onUpdateStatus }) => {
  const history = useHistory();

  const renderReportDetails = (report) => (
    <>
      <Text mb={2} color="gray.500" fontSize="sm">
        <strong>Reported By:</strong> {report.reportedBy}
      </Text>
      <Text mb={2} color="gray.500" fontSize="sm">
        <strong>Reported Date:</strong> {new Date(report.date).toLocaleDateString()}
      </Text>
      <Text mb={2} color="gray.500" fontSize="sm">
        <strong>Details:</strong> {report.details}
      </Text>
    </>
  );

  const renderMenuItems = (report) => [
    {
      icon: <AlarmClockPlus size={16} />,
      text: "Mark as Unread",
      onClick: () => onUpdateStatus(report.id, "Unread"),
    },
    {
      icon: <Pickaxe size={16} />,
      text: "Mark as Pending",
      onClick: () => onUpdateStatus(report.id, "Pending"),
    },
    {
      icon: <CircleCheckBig size={16} />,
      text: "Mark as Resolved",
      onClick: () => onUpdateStatus(report.id, "Resolved"),
    },
    {
      icon: <MessageCircle size={16} />,
      text: "Chat",
      onClick: () => history.push("/admin/messages"),
    },
  ];

  return (
    <ReportList
      reports={reports}
      renderReportDetails={renderReportDetails}
      renderMenuItems={renderMenuItems}
      noDataMessage="No package reports found"
    />
  );
};

export default PackageReports;
